'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import PropTypes from 'prop-types';
import { Component, Fragment } from 'react';
import styled from 'styled-components';
import UISelect from 'UIComponents/input/UISelect';
import UIIcon from 'UIComponents/icon/UIIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { SLINKY } from 'HubStyleTokens/colors';
import { getDocAnchorId } from '../utils/DocsUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledCode = styled.code.withConfig({
  displayName: "EndpointSelect__StyledCode",
  componentId: "sa5mdr-0"
})(["color:", ";"], SLINKY);
const StyledFixedWidthDiv = styled.div.withConfig({
  displayName: "EndpointSelect__StyledFixedWidthDiv",
  componentId: "sa5mdr-1"
})(["width:450px;"]);
const CustomIconValue = _ref => {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs("span", Object.assign({}, rest, {
    children: [/*#__PURE__*/_jsx(UIIcon, {
      className: "m-right-2",
      name: "bulletCircle",
      size: 24,
      color: SLINKY
    }), children]
  }));
};
class EndpointSelect extends Component {
  constructor(props) {
    super(props);
    this.options = this.getOptions();
  }
  onSelectChange({
    target: {
      value
    }
  }) {
    if (value) {
      window.location.hash = `#${value}`;
    }
  }

  // Makes options structure UISelect can accept from docs
  // sorted to match order of sectionHeadings, if sectionHeadings exists. i.e.
  // [{ text: "Basic", options: { text: ..., value: ..., help: ... } }, ...]
  getOptions() {
    const selectOption = doc => {
      return {
        text: doc.title,
        value: getDocAnchorId(doc.api.method, doc.swagger.path),
        help: this.renderOptionHelp(doc.api.method, doc.swagger.path)
      };
    };

    // Create flat list of options if no headings
    if (this.props.sectionHeadings.length === 0) {
      return this.props.docs.map(doc => {
        return selectOption(doc);
      });
    }

    // Otherwise group options by section heading
    const grouped = this.props.docs.reduce((h, doc) => {
      const idx = h.findIndex(x => x.text === doc.slug);
      if (idx === -1) {
        h.push({
          text: doc.slug,
          options: [selectOption(doc)]
        });
      } else {
        h[idx].options.push(selectOption(doc));
      }
      return h;
    }, []);

    // Sort so options are in same order as section headings
    return grouped.sort((a, b) => {
      return this.props.sectionHeadings.indexOf(a.text) - this.props.sectionHeadings.indexOf(b.text);
    });
  }
  renderOptionHelp(method, path) {
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: `developer-docs-shared-components.methods.${method.toLowerCase()}`
      }), /*#__PURE__*/_jsx(StyledCode, {
        className: "transparent",
        children: path
      })]
    });
  }
  render() {
    return /*#__PURE__*/_jsx(StyledFixedWidthDiv, {
      className: "m-bottom-4",
      children: /*#__PURE__*/_jsx(UISelect, {
        className: this.props.className,
        onChange: this.onSelectChange,
        options: this.options,
        placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "endpoints.search.placeholder"
        }),
        valueComponent: CustomIconValue
      })
    });
  }
}
EndpointSelect.propTypes = {
  docs: PropTypes.array.isRequired,
  sectionHeadings: PropTypes.array.isRequired,
  className: PropTypes.string
};
export default EndpointSelect;